<script>
/**
 *
 * @version 1.0.0
 * @since
 */
export default {
  name: 'VPdfPlaceholder',
  props: {
    dataCy: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<template>
  <a @click="$emit('click')" :data-cy="dataCy">
    <div class="pdf-container">
      <font-awesome-icon class="pdf-icon" icon="file-pdf" />
    </div>
  </a>
</template>

<style scoped lang="scss">
.pdf-container {
  @include size(100%);

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid $color-gray-E1;
  border-radius: 3px;
  background-color: $color-gray-F5;

  svg {
    font-size: 24px;
    color: $color-gray-6C;
  }
}
</style>
